import React, { useCallback, useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import { FaRegTrashAlt } from "react-icons/fa";
import { Submit } from "../../components/buttons";
import { Input, Textarea } from "../../components/inputs";
import ToggleButton from "../../components/toggle-button";
import { generateObjectId } from "../../utilities/helpers";
import { BASE, useFetch } from "../../utilities/apis";
import { showToast } from "../../utilities/toast";

const AddDepartment = ({ exams }) => {
  const [exam, setExam] = useState("");
  const { post } = useFetch();
  const [department_code, setDepartment_Code] = useState("");
  const [department_title, setDepartment_Title] = useState("");
  const [department_order, setDepartment_Order] = useState(0);
  const [askAI, setAskAI] = useState(false);
  const [aiPrompts, setAiPrompts] = useState([]);

  const addAiPromptInput = useCallback(() => {
    setAiPrompts((prev) => [
      ...prev,
      { id: generateObjectId(), text: "", prompt: "" },
    ]);
  }, []);

  const onAiPromptTextChange = useCallback((value, id) => {
    setAiPrompts((prev) => {
      const clone = [...prev];
      const index = clone.findIndex((e) => e.id === id);
      if (index !== -1) clone[index].text = value;
      return clone;
    });
  }, []);

  const onAiPromptChange = useCallback((value, id) => {
    setAiPrompts((prev) => {
      const clone = [...prev];
      const index = clone.findIndex((e) => e.id === id);
      if (index !== -1) clone[index].prompt = value;
      return clone;
    });
  }, []);

  const deleteAiPromptInput = useCallback((id) => {
    setAiPrompts((prev) => prev.filter((item) => item.id !== id));
  }, []);

  function collectData(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    let selectedExam = [];
    for (let i = 0; i <= exams.length; i++) {
      if (formData.get("checkbox" + i)) {
        selectedExam.push(formData.get("checkbox" + i));
      }
    }
    selectedExam = selectedExam.filter(function (item, pos, self) {
      return self.indexOf(item) === pos;
    });
    const data = {
      exams: selectedExam,
      code: department_code,
      title: department_title,
      type: "department",
      order: Number(department_order),
      askAI,
      aiPrompts: aiPrompts.map(({ text, prompt }) => ({ text, prompt })),
    };

    try {
      post(BASE + "new", data, (error, _) => {
        if (error) return console.log(error);
      });
      setDepartment_Code("");
      setDepartment_Title("");
      setDepartment_Order(0);
      setAskAI(false);
      setAiPrompts([]);
      showToast({ type: "success", message: "Successfully added department!" });
    } catch (err) {
      showToast({ type: "error", message: err.response.data.message });
    }
  }

  return (
    <>
      <div className="d-flex flex-row justify-content-around mb-4 ">
        <div className="border p-3 w-100">
          <h6>Add Department</h6>

          <form onSubmit={collectData}>
            <label htmlFor="examCode">Exam</label>
            <div className="form-group  d-flex justify-content-center mb-3 flex-wrap gap-5">
              {exams.map((exam, index) => {
                return (
                  <div className="test-series-subject-input" key={index}>
                    <div className="form-check">
                      <label
                        htmlFor={"checkbox" + (index + 1)}
                        className="form-check-label"
                      >
                        {exam.title}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        onChange={setExam}
                        value={exam._id}
                        id={"checkbox" + (index + 1)}
                        name={"checkbox" + (index + 1)}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            <Input
              id="examCode"
              value={department_code}
              label="Department Code"
              onChange={setDepartment_Code}
              type={"text"}
            />
            <Input
              id="examTitle"
              value={department_title}
              label="Department Title"
              onChange={setDepartment_Title}
              type={"text"}
            />
            <Input
              id="departmentOrder"
              value={department_order}
              label="Rank"
              onChange={setDepartment_Order}
              type={"number"}
            />
            <div className="form-group mt-2 mb-3">
              <ToggleButton
                label="Ask AI"
                value={askAI}
                onChange={setAskAI}
              />
            </div>

            <div className="mt-3 mb-3">
              <div className="d-flex align-items-center gap-2 mb-2">
                <h6 className="mb-0">AI Prompts</h6>
                <CiCirclePlus
                  onClick={addAiPromptInput}
                  className="cursor-pointer !text-primary"
                  size={24}
                />
              </div>

              {aiPrompts.map(({ id, text, prompt }) => (
                <div key={id} className="d-flex gap-3 align-items-start border p-3 mb-2">
                  <div className="flex-grow-1">
                    <Input
                      value={text}
                      onChange={(value) => onAiPromptTextChange(value, id)}
                      label="Button Text"
                      placeholder="e.g. Learn the Concept"
                    />
                    <Textarea
                      value={prompt}
                      onChange={(value) => onAiPromptChange(value, id)}
                      label="Prompt"
                      placeholder="Prompt sent to the AI"
                      rows={3}
                    />
                  </div>

                  <FaRegTrashAlt
                    onClick={() => deleteAiPromptInput(id)}
                    className="cursor-pointer mt-2"
                  />
                </div>
              ))}
            </div>

            <div>
              <div className="col">
                <Submit
                  disabled={
                    !department_title || !department_code || exam === ""
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddDepartment;
